/**
 * MS-10 wave2 (Cowork · 2026-06-07) · клик по иконке роли → скролл к drawer
 * роли + автораскрытие + вспышка. Связывает «карту команды» с деталями.
 *
 * Markup contract (per sprint-01.ts MS-10):
 *   <div class='role-icon'><svg…/><span class='role-name' data-role='X'>…</span>…</div>
 *   …<div class='drawer' id='dr-X'>…
 *
 * Карточка QA (data-role='qa') получает класс .you (accent-выделение).
 * Drawer открывается классом .open (контракт drawers.ts production).
 */
export function initRoleIcons(root: HTMLElement): () => void {
  const names = Array.from(
    root.querySelectorAll<HTMLElement>('.role-icon .role-name[data-role]'),
  );
  const cleanups: Array<() => void> = [];

  for (const name of names) {
    const icon = name.closest<HTMLElement>('.role-icon');
    if (!icon || icon.dataset.riInit === '1') continue;
    icon.dataset.riInit = '1';
    if (name.dataset.role === 'qa') icon.classList.add('you');
    if (!icon.hasAttribute('tabindex')) icon.tabIndex = 0;
    if (!icon.hasAttribute('role')) icon.setAttribute('role', 'button');

    const go = () => {
      const drawer = root.querySelector<HTMLElement>('#dr-' + name.dataset.role);
      if (!drawer) return;
      drawer.classList.add('open');
      drawer.classList.remove('flash');
      void drawer.offsetWidth;
      drawer.classList.add('flash');
      if (typeof drawer.scrollIntoView === 'function') {
        try {
          drawer.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch {
          drawer.scrollIntoView();
        }
      }
    };

    const onClick = () => go();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        go();
      }
    };
    icon.addEventListener('click', onClick);
    icon.addEventListener('keydown', onKey);
    cleanups.push(() => {
      icon.removeEventListener('click', onClick);
      icon.removeEventListener('keydown', onKey);
      delete icon.dataset.riInit;
    });
  }

  return () => cleanups.forEach((fn) => fn());
}
